// extracted by mini-css-extract-plugin
export default {"page":"aN","freeShippingContainer":"bN","customizeContainer":"cN","customizeHeader":"eN","fadein":"fN","customizeText":"gN","hidden":"hN","productcard":"iN","accordeonscontainer":"jN","freeShipping":"kN","mainpart":"lN"};
    if(module.hot) {
      // 1713361652310
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  